import { Box } from '@chakra-ui/react';
import React from 'react';
import { RouteComponentProps } from 'react-router';

import { ApproveFundingRequest } from 'capitalProvider/domains/fundingRequests/ui/ApproveFundingRequestContainer';
import { dashboardRoutePadding } from 'packages/common-frontend/constants';

interface FundingRequestApproveRouteMatchParams {
  fundingRequestId: string;
}

interface FundingRequestApproveRouteProps
  extends RouteComponentProps<FundingRequestApproveRouteMatchParams> {}

export const FundingRequestApproveRoute = (
  routeParams: FundingRequestApproveRouteProps,
) => {
  const { fundingRequestId } = routeParams.match.params;

  return (
    <Box padding={dashboardRoutePadding}>
      <ApproveFundingRequest fundingRequestId={fundingRequestId} />
    </Box>
  );
};
